import { createElement, Fragment } from 'react';
import { number, node, shape, bool, func, string, object } from 'prop-types';
import { withTheme } from 'reakit/styled';
import _get from 'lodash/get';
import '../styled/index.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import Portal from '../Portal/index.js';
import { b as buttonPropTypes } from '../chunk-68945c57.js';
import _omit from 'lodash/omit';
import { b as panePropTypes, c as paneDefaultProps } from '../chunk-895bf8c9.js';
import _Toast, { CountdownBar, Content, Toasts } from './styled.js';
import ToastContainer from './ToastContainer.js';
import ToastClose from './ToastClose.js';
import ToastIcon from './ToastIcon.js';
import ToastTitle from './ToastTitle.js';

var Toast = function Toast(_ref) {
  var autoDismissTimeout = _ref.autoDismissTimeout,
      children = _ref.children,
      closeButtonProps = _ref.closeButtonProps,
      hasHorizontalBar = _ref.hasHorizontalBar,
      hasIcon = _ref.hasIcon,
      hideCloseButton = _ref.hideCloseButton,
      onClickClose = _ref.onClickClose,
      showCountdownBar = _ref.showCountdownBar,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["autoDismissTimeout", "children", "closeButtonProps", "hasHorizontalBar", "hasIcon", "hideCloseButton", "onClickClose", "showCountdownBar", "title", "type"]);

  return createElement(_Toast, _extends({
    role: "alert",
    type: type
  }, props), showCountdownBar && createElement(Fragment, null, createElement(CountdownBar, {
    isHorizontal: hasHorizontalBar,
    type: type,
    isBackground: true
  }), createElement(CountdownBar, {
    isHorizontal: hasHorizontalBar,
    type: type,
    autoDismissTimeout: autoDismissTimeout
  })), createElement(Content, {
    showCountdownBar: showCountdownBar
  }, hasIcon && type && createElement(ToastIcon, {
    type: type,
    size: children ? '300' : undefined
  }), createElement(Box, null, title && createElement(ToastTitle, {
    marginBottom: children ? 'minor-2' : undefined
  }, title), children)), !hideCloseButton && createElement(ToastClose, _extends({
    isAbsolute: Boolean(children),
    onClickClose: onClickClose
  }, closeButtonProps)));
};
Toast.Container = ToastContainer;
var toastPropTypes = _objectSpread({
  autoDismissTimeout: number,
  children: node,
  closeButtonProps: shape(_omit(buttonPropTypes, 'children')),
  hasHorizontalBar: bool,
  hasIcon: bool,
  hasTint: bool,
  hideCloseButton: bool,
  onClickClose: func,
  showCountdownBar: bool,
  type: string,
  title: string
}, panePropTypes);
Toast.propTypes = toastPropTypes;
var toastDefaultProps = _objectSpread({}, paneDefaultProps, {
  autoDismissTimeout: undefined,
  children: undefined,
  closeButtonProps: {},
  elevation: '300',
  hasHorizontalBar: false,
  hasIcon: true,
  hasTint: false,
  hideCloseButton: false,
  onClickClose: undefined,
  showCountdownBar: true,
  title: undefined,
  type: 'info'
});
Toast.defaultProps = toastDefaultProps;
var C = Toast;

var ToastManager = function ToastManager(_ref) {
  var theme = _ref.theme;

  var ToastComponent = _get(theme, 'fannypack.Toast.component', C);

  var defaultProps = _get(theme, 'fannypack.Toast.defaultProps', {});

  var placement = _get(theme, 'fannypack.Toast.placement', 'top-end');

  var isStacked = _get(theme, 'fannypack.Toast.isStacked', true);

  return createElement(Portal, null, createElement(Toasts, {
    placement: placement
  }, createElement(ToastContainer, {
    placement: placement
  }, function (state) {
    return [].concat(isStacked ? state.toasts : [state.toasts[0]]).filter(Boolean).map(function (toast) {
      return createElement(ToastComponent, _extends({
        key: toast.key,
        onClickClose: function onClickClose() {
          return state.remove({
            key: toast.key
          });
        }
      }, defaultProps, toast), toast.message);
    });
  })));
};
var toastManagerPropTypes = {
  theme: object
};
ToastManager.propTypes = toastManagerPropTypes;
var toastManagerDefaultProps = {
  theme: {
    fannypack: {}
  }
};
ToastManager.defaultProps = toastManagerDefaultProps;
var ToastManager$1 = withTheme(ToastManager);

export { ToastManager$1 as a, C as b, ToastManager as c, toastManagerPropTypes as d, toastManagerDefaultProps as e, toastPropTypes as f, toastDefaultProps as g };
